.treeContainer {
    overflow: auto;
}
